.treeContainer {
    overflow: auto;
}
